import { Center, Paper, Image, Divider, Stack } from '@mantine/core';
import React from 'react';

import { LegalLinks } from '@/components';
import config from '@/config';

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <Stack h="100vh" justify="space-between">
        <Center h="100%">
          <Paper style={{ width: '350px' }} radius="md" p="xl" withBorder>
            <Image h={30} fit="contain" src={config.brand.logo} alt="logo" />
            <Divider label="Please sign in" labelPosition="center" my="lg" />
            {children}
          </Paper>
        </Center>
        <div>
          <LegalLinks />
          <p style={{ textAlign: 'center' }}>© {config.brand.company}</p>
        </div>
      </Stack>
    </>
  );
};
